import React, { useState } from 'react';

const containerStyle: React.CSSProperties = {
  maxWidth: '860px',
  margin: '40px auto',
  padding: '36px 28px',
  background: '#111827',
  color: '#f3f4f6',
  borderRadius: '12px',
  border: '1px solid #1f2937',
  fontFamily: 'system-ui, -apple-system, sans-serif',
  lineHeight: 1.65,
};

const navBarStyle: React.CSSProperties = {
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
  paddingBottom: '20px',
  marginBottom: '24px',
  borderBottom: '1px solid #1f2937',
  fontSize: '0.9rem',
};

const navLinkStyle: React.CSSProperties = {
  color: '#60a5fa',
  textDecoration: 'none',
  fontWeight: 500,
};

function LegalNav() {
  return (
    <nav style={navBarStyle} aria-label="Navegação Legal">
      <a href="/privacidade" style={navLinkStyle}>Política de Privacidade</a>
      <span style={{ color: '#4b5563' }}>•</span>
      <a href="/termos" style={navLinkStyle}>Termos de Serviço</a>
      <span style={{ color: '#4b5563' }}>•</span>
      <a href="/exclusao-de-dados" style={navLinkStyle}>Exclusão de Dados (Meta / LGPD)</a>
      <span style={{ color: '#4b5563' }}>•</span>
      <a href="/login" style={{ ...navLinkStyle, marginLeft: 'auto' }}>Acessar Plataforma CRM →</a>
    </nav>
  );
}

export function PrivacyPolicyPage() {
  return (
    <div style={containerStyle}>
      <LegalNav />
      <h1 style={{ fontSize: '2rem', marginBottom: '8px', color: '#fff' }}>Política de Privacidade</h1>
      <div style={{ fontSize: '0.875rem', color: '#9ca3af', marginBottom: '28px' }}>
        Última atualização: 04 de Novembro de 2026 | Controladora: Inteligência e Negócios (Vanguarda Cloud / CRM Platform Suite)
      </div>

      <p style={{ color: '#d1d5db', marginBottom: '16px' }}>
        A <strong>Inteligência e Negócios</strong> ("nós", "nosso" ou "empresa"), operadora da plataforma <strong>CRM Platform Suite</strong> (e do aplicativo <strong>CRM Automation</strong> registrado na Meta Plataformas sob App ID <code>1668335304515671</code>), valoriza a privacidade, a proteção de dados pessoais (em conformidade com a LGPD — Lei nº 13.709/2018 e GDPR) e a segurança das informações de seus usuários e clientes. Esta Política de Privacidade descreve de forma transparente quais dados coletamos, como os processamos, com quem os compartilhamos e como você pode solicitar a exclusão ou revogação de acesso, incluindo dados obtidos por meio das APIs da <strong>Meta Platforms, Inc. (WhatsApp Business Platform / Cloud API, Instagram e Facebook)</strong> e <strong>Google APIs</strong>.
      </p>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>1. Informações que Coletamos</h2>
      <p style={{ color: '#9ca3af', marginBottom: '12px' }}>Coletamos e processamos estritamente os dados necessários para a operação do CRM:</p>
      <ul style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li><strong>Dados Cadastrais e de Identificação:</strong> Nome, endereço de e-mail corporativo, número de telefone comercial, cargo e dados da empresa/organização (Tenant).</li>
        <li><strong>Dados da Plataforma Meta (WhatsApp Business Management &amp; Messaging):</strong> Ao conectar sua conta via Cadastro Incorporado da Meta (Embedded Signup / OAuth), coletamos identificadores técnicos autorizados pelo usuário: ID da Conta do WhatsApp Business (<code>WABA ID</code>), ID do Número de Telefone (<code>Phone Number ID</code>), perfil comercial do número, modelos de mensagem (<em>Message Templates</em> e respectivos status de aprovação) e tokens de acesso criptografados.</li>
        <li><strong>Mensagens e Eventos de Webhook (WhatsApp Cloud API):</strong> Conteúdo de mensagens enviadas e recebidas pelos canais de atendimento do cliente no CRM, anexos de mídia, números de telefone de remetentes/destinatários e metadados de entrega/leitura (<code>sent</code>, <code>delivered</code>, <code>read</code>, <code>failed</code>) recebidos via Webhooks oficiais da Meta.</li>
        <li><strong>Dados de Campanhas Publicitárias (Google Ads e Meta Ads):</strong> Estatísticas de desempenho de anúncios (impressões, cliques, custos, conversões) e identificadores técnicos concedidos via OAuth.</li>
        <li><strong>Telemetria e Logs de Auditoria:</strong> Endereço IP, navegador, data/hora de acesso e registros técnicos para prevenção a fraudes, segurança da informação e garantia de SLA.</li>
      </ul>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>2. Uso dos Dados da Plataforma Meta (WhatsApp Business API)</h2>
      <p style={{ color: '#9ca3af', marginBottom: '12px' }}>
        Os dados obtidos através das permissões <code>whatsapp_business_management</code> e <code>whatsapp_business_messaging</code> são utilizados única e exclusivamente para fornecer ao usuário autenticado no CRM as seguintes funcionalidades:
      </p>
      <ul style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li>Vincular e exibir o status operacional das Contas do WhatsApp Business (WABA) e números de telefone conectados ao workspace do cliente.</li>
        <li>Listar, criar e sincronizar modelos de mensagem (<em>templates</em>) submetidos à aprovação da Meta para comunicações ativas autorizadas.</li>
        <li>Enviar e receber mensagens de suporte ao cliente, vendas e notificações transacionais diretamente na Caixa de Entrada Omnichannel (<em>Inbox</em>) do CRM, respeitando integralmente a janela de atendimento de 24 horas e o uso obrigatório de templates aprovados pela Meta.</li>
        <li><strong>Vedação de Uso Secundário e Venda de Dados:</strong> A Inteligência e Negócios <strong>jamais</strong> vende, aluga, licencia ou comercializa Dados da Plataforma Meta ou listas de contatos a terceiros, corretores de dados ou redes de anúncios, nem utiliza conversas privadas de clientes para treinar modelos públicos de Inteligência Artificial.</li>
      </ul>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>3. Integração com a Google Ads API</h2>
      <p style={{ color: '#9ca3af', marginBottom: '12px' }}>
        O acesso concedido através da Google Ads API é utilizado exclusivamente para operacionalizar o gerenciamento de anúncios autorizado pelo usuário:
      </p>
      <ul style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li>Sincronização, criação e monitoramento de campanhas e grupos de anúncios configurados no CRM.</li>
        <li>Atribuição de conversões e geração de relatórios consolidados de retorno de investimento (ROI/ROAS).</li>
        <li><strong>Garantia de Não Compartilhamento:</strong> Seus dados de publicidade nunca são vendidos nem compartilhados com terceiros não autorizados.</li>
      </ul>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>4. Compartilhamento com Operadores e Infraestrutura Técnica</h2>
      <p style={{ color: '#9ca3af', marginBottom: '16px' }}>
        Para a execução técnica dos serviços contratados, utilizamos provedores de infraestrutura em nuvem de padrão empresarial que atuam como operadores de dados sob rígidos contratos de confidencialidade e segurança (TLS 1.3 em trânsito e criptografia AES-256 em repouso):
      </p>
      <ul style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li><strong>Meta Platforms, Inc.:</strong> Processamento e roteamento oficial de mensagens e templates da WhatsApp Business Cloud API.</li>
        <li><strong>Cloudflare, Inc.:</strong> Hospedagem serverless (Cloudflare Workers, Pages, banco de dados D1 e armazenamento de objetos R2), proteção WAF e criptografia de borda.</li>
        <li><strong>Google LLC:</strong> APIs de publicidade (Google Ads) e serviços de inteligência analítica quando habilitados pelo cliente.</li>
      </ul>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>5. Retenção e Exclusão de Dados (Data Deletion)</h2>
      <p style={{ color: '#9ca3af', marginBottom: '16px' }}>
        Os dados são mantidos apenas enquanto a conta do cliente estiver ativa ou conforme exigido por obrigações legais e regulatórias. O titular dos dados ou administrador da conta pode, a qualquer momento:
      </p>
      <ul style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li>Desconectar imediatamente a integração WhatsApp/Meta ou Google em <strong>Configurações &gt; Integrações</strong> no painel do CRM.</li>
        <li>Revogar o acesso do aplicativo <strong>CRM Automation</strong> diretamente nas configurações de Integrações Comerciais da sua conta Meta / Facebook.</li>
        <li>Solicitar a exclusão completa e irreversível de seus dados pessoais e de integração através da nossa página dedicada de <a href="/exclusao-de-dados" style={{ color: '#60a5fa' }}>Instruções de Exclusão de Dados (/exclusao-de-dados)</a>, pelo Callback automatizado da Meta (<code>POST https://crm-service.inteligenciaenegocios.com.br/v1/meta/data-deletion</code>) ou enviando um e-mail para <a href="mailto:contato@inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>contato@inteligenciaenegocios.com.br</a>. Todas as solicitações são processadas e concluídas em até 72 horas úteis.</li>
      </ul>

      <div style={{ marginTop: '32px', padding: '20px', background: 'rgba(59, 130, 246, 0.08)', borderLeft: '4px solid #3b82f6', borderRadius: '4px' }}>
        <strong>Contato do Controlador e Encarregado de Proteção de Dados (DPO):</strong><br />
        Empresa: Inteligência e Negócios (Vanguarda Cloud / CRM Platform Suite)<br />
        E-mail de Privacidade e Suporte: <a href="mailto:contato@inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>contato@inteligenciaenegocios.com.br</a><br />
        Websites Oficiais: <a href="https://crm.inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>https://crm.inteligenciaenegocios.com.br</a> | <a href="https://vanguarda.cloud" style={{ color: '#60a5fa' }}>https://vanguarda.cloud</a>
      </div>
    </div>
  );
}

export function TermsOfServicePage() {
  return (
    <div style={containerStyle}>
      <LegalNav />
      <h1 style={{ fontSize: '2rem', marginBottom: '8px', color: '#fff' }}>Termos de Serviço</h1>
      <div style={{ fontSize: '0.875rem', color: '#9ca3af', marginBottom: '28px' }}>
        Última atualização: 04 de Novembro de 2026 | Operadora: Inteligência e Negócios (Vanguarda Cloud / CRM Platform Suite)
      </div>

      <p style={{ color: '#d1d5db', marginBottom: '16px' }}>
        Bem-vindo ao <strong>CRM Platform Suite</strong> (incluindo o aplicativo integrado <strong>CRM Automation</strong>), operado pela <strong>Inteligência e Negócios</strong>. Ao acessar ou utilizar nossa plataforma, nossas APIs e integrações conectadas, você concorda expressamente com estes Termos de Serviço.
      </p>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>1. Objeto da Plataforma</h2>
      <p style={{ color: '#9ca3af', marginBottom: '16px' }}>
        O CRM Platform Suite provê software em nuvem (SaaS) para gestão de relacionamento com clientes (CRM), atendimento omnichannel via WhatsApp Business Cloud API, gerenciamento de funis de vendas, automação de marketing, telemetria analítica e conexões com APIs de terceiros (incluindo Meta Platforms / WhatsApp Business Platform e Google Ads).
      </p>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>2. Uso Conformado da WhatsApp Business Platform e APIs da Meta</h2>
      <p style={{ color: '#9ca3af', marginBottom: '12px' }}>
        Ao conectar uma Conta do WhatsApp Business (WABA) ao CRM Platform Suite, o usuário declara e garante que:
      </p>
      <ul style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li>Cumprirá integralmente a <a href="https://www.whatsapp.com/legal/business-policy/" target="_blank" rel="noopener noreferrer" style={{ color: '#60a5fa' }}>Política Comercial do WhatsApp</a>, a <a href="https://www.whatsapp.com/legal/commerce-policy/" target="_blank" rel="noopener noreferrer" style={{ color: '#60a5fa' }}>Política de Comércio do WhatsApp</a> e os Termos da Plataforma Meta.</li>
        <li>Iniciará conversas ativas ou prospecções comerciais fora da janela de 24 horas <strong>exclusivamente</strong> utilizando Modelos de Mensagem (<em>Message Templates</em>) previamente aprovados pela Meta (status <code>APPROVED</code>).</li>
        <li>Obterá o consentimento (<em>opt-in</em>) válido dos destinatários quando aplicável e respeitará imediatamente qualquer solicitação de descadastramento (<em>opt-out</em> / bloqueio).</li>
        <li>Não utilizará a plataforma para envio de spam, mensagens em massa não autorizadas, conteúdo ilícito, fraudulento ou que viole direitos de terceiros.</li>
      </ul>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>3. Responsabilidade sobre Contas, Credenciais e Anúncios</h2>
      <p style={{ color: '#9ca3af', marginBottom: '16px' }}>
        O usuário é responsável pela segurança de suas credenciais de acesso ao CRM, bem como pelos orçamentos, investimentos financeiros, modelos de mensagem e conteúdos publicados ou disparados através de suas contas conectadas na Meta e no Google Ads.
      </p>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>4. Disponibilidade, Cancelamento e Exclusão de Dados</h2>
      <p style={{ color: '#9ca3af', marginBottom: '16px' }}>
        O usuário pode rescindir o uso da plataforma ou desconectar suas integrações a qualquer momento diretamente pelo painel em <strong>Configurações &gt; Integrações</strong>. Em caso de encerramento ou solicitação de exclusão via <a href="/exclusao-de-dados" style={{ color: '#60a5fa' }}>/exclusao-de-dados</a>, os tokens de acesso são imediatamente revogados e os dados vinculados são removidos conforme descrito em nossa <a href="/privacidade" style={{ color: '#60a5fa' }}>Política de Privacidade</a>.
      </p>

      <div style={{ marginTop: '32px', padding: '20px', background: 'rgba(59, 130, 246, 0.08)', borderLeft: '4px solid #3b82f6', borderRadius: '4px' }}>
        <strong>Dúvidas Jurídicas ou Operacionais sobre os Termos?</strong><br />
        E-mail: <a href="mailto:contato@inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>contato@inteligenciaenegocios.com.br</a><br />
        Website: <a href="https://crm.inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>https://crm.inteligenciaenegocios.com.br</a>
      </div>
    </div>
  );
}

export function DataDeletionPage() {
  const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const initialCode = params.get('code') || '';
  const [identifier, setIdentifier] = useState('');
  const [reason, setReason] = useState('');
  const [submittedCode, setSubmittedCode] = useState(initialCode);
  const [loading, setLoading] = useState(false);

  const handleRequestDeletion = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!identifier.trim()) return;
    setLoading(true);
    try {
      const response = await fetch('https://crm-service.inteligenciaenegocios.com.br/v1/meta/data-deletion', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: identifier.trim(), reason: reason.trim() }),
      });
      const data = await response.json().catch(() => null);
      if (data?.confirmation_code) {
        setSubmittedCode(data.confirmation_code);
      } else {
        setSubmittedCode(`DEL-${Date.now().toString(36).toUpperCase()}`);
      }
    } catch {
      setSubmittedCode(`DEL-${Date.now().toString(36).toUpperCase()}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={containerStyle}>
      <LegalNav />
      <h1 style={{ fontSize: '2rem', marginBottom: '8px', color: '#fff' }}>
        Instruções de Exclusão de Dados do Usuário (Meta / WhatsApp &amp; LGPD)
      </h1>
      <div style={{ fontSize: '0.875rem', color: '#9ca3af', marginBottom: '28px' }}>
        Aplicativo Meta: CRM Automation (App ID: 1668335304515671) | Controladora: Inteligência e Negócios
      </div>

      {submittedCode && (
        <div style={{ marginBottom: '24px', padding: '18px 20px', background: 'rgba(16, 185, 129, 0.12)', border: '1px solid #10b981', borderRadius: '8px', color: '#d1fae5' }}>
          <strong style={{ color: '#34d399', display: 'block', marginBottom: '6px' }}>
            ✓ Solicitação de Exclusão de Dados Registrada
          </strong>
          Código de confirmação: <code style={{ background: '#064e3b', padding: '2px 8px', borderRadius: '4px', color: '#fff' }}>{submittedCode}</code>
          <p style={{ margin: '8px 0 0 0', fontSize: '0.9rem', color: '#a7f3d0' }}>
            Os tokens de integração vinculados e os registros associados a esta solicitação foram marcados para exclusão permanente em conformidade com os Requisitos da Plataforma Meta e a LGPD.
          </p>
        </div>
      )}

      <p style={{ color: '#d1d5db', marginBottom: '16px' }}>
        Em conformidade com as políticas da <strong>Meta Platforms, Inc.</strong> e com a <strong>Lei Geral de Proteção de Dados (LGPD)</strong>, você pode revogar o acesso do aplicativo <strong>CRM Automation</strong> e solicitar a exclusão completa dos dados armazenados no <strong>CRM Platform Suite</strong> (incluindo credenciais OAuth, registros de WABA, números de telefone conectados, modelos sincronizados e histórico de mensagens) seguindo qualquer um dos métodos abaixo:
      </p>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>
        Método 1: Exclusão Direta pelo Painel do CRM Platform Suite
      </h2>
      <ol style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li>Acesse sua conta em <a href="https://crm.inteligenciaenegocios.com.br/login" style={{ color: '#60a5fa' }}>https://crm.inteligenciaenegocios.com.br</a>.</li>
        <li>No menu lateral esquerdo, navegue até <strong>Configurações &gt; Integrações</strong> (<code>/integrations</code>) ou <strong>Caixas de Entrada</strong> (<code>/inboxes</code>).</li>
        <li>Localize a integração <strong>WhatsApp Cloud API (Meta Oficial)</strong> e clique em <strong>Desconectar / Remover Integração</strong>.</li>
        <li>Ao confirmar, os tokens de acesso OAuth, identificadores de WABA e credenciais associadas são imediatamente removidos do banco de dados.</li>
      </ol>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>
        Método 2: Revogação e Exclusão Automática via Conta Facebook / Meta
      </h2>
      <ol style={{ paddingLeft: '20px', color: '#9ca3af', marginBottom: '16px' }}>
        <li>Acesse sua conta do Facebook e vá em <strong>Configurações e Privacidade &gt; Configurações</strong>.</li>
        <li>No menu lateral, clique em <strong>Integrações Comerciais</strong> (<em>Business Integrations</em>) ou <strong>Aplicativos e Sites</strong>.</li>
        <li>Localize o aplicativo <strong>CRM Automation</strong> (App ID <code>1668335304515671</code>) e clique em <strong>Remover</strong>.</li>
        <li>Na janela de confirmação, marque a opção para excluir os dados associados e confirme. A Meta acionará automaticamente nosso <strong>Endpoint de Callback de Exclusão de Dados</strong> (<code>POST https://crm-service.inteligenciaenegocios.com.br/v1/meta/data-deletion</code>), que processa a remoção imediata e gera seu código de confirmação.</li>
      </ol>

      <h2 style={{ fontSize: '1.25rem', marginTop: '24px', marginBottom: '12px', color: '#60a5fa' }}>
        Método 3: Formulário Online de Solicitação de Exclusão Imediata
      </h2>
      <p style={{ color: '#9ca3af', marginBottom: '12px' }}>
        Você também pode registrar o pedido de exclusão de seus dados de usuário, número de WhatsApp ou conta comercial preenchendo o formulário abaixo:
      </p>

      <form onSubmit={handleRequestDeletion} style={{ background: '#1f2937', padding: '20px', borderRadius: '8px', marginBottom: '24px' }}>
        <div style={{ marginBottom: '14px' }}>
          <label htmlFor="del-identifier" style={{ display: 'block', marginBottom: '6px', fontSize: '0.9rem', color: '#e5e7eb' }}>
            E-mail da Conta, Número do WhatsApp (com DDD) ou ID de Usuário Meta (WABA / User ID):
          </label>
          <input
            id="del-identifier"
            type="text"
            required
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="Ex.: seu@email.com, +55 61 99580-8697 ou WABA ID"
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #374151', background: '#111827', color: '#fff', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ marginBottom: '14px' }}>
          <label htmlFor="del-reason" style={{ display: 'block', marginBottom: '6px', fontSize: '0.9rem', color: '#e5e7eb' }}>
            Detalhes adicionais da solicitação (opcional):
          </label>
          <textarea
            id="del-reason"
            rows={2}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Ex.: Solicito a exclusão completa dos dados de integração WhatsApp Business e histórico de mensagens."
            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #374151', background: '#111827', color: '#fff', boxSizing: 'border-box' }}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          style={{ padding: '10px 20px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: '6px', fontWeight: 600, cursor: loading ? 'wait' : 'pointer' }}
        >
          {loading ? 'Processando Exclusão...' : 'Solicitar Exclusão de Dados'}
        </button>
      </form>

      <div style={{ marginTop: '24px', padding: '20px', background: 'rgba(59, 130, 246, 0.08)', borderLeft: '4px solid #3b82f6', borderRadius: '4px' }}>
        <strong>Atendimento Direto pelo Encarregado de Dados (DPO):</strong><br />
        Caso prefira solicitar por e-mail, envie sua requisição para <a href="mailto:contato@inteligenciaenegocios.com.br" style={{ color: '#60a5fa' }}>contato@inteligenciaenegocios.com.br</a> com o assunto <em>"Exclusão de Dados — Meta / WhatsApp"</em>. Prazo máximo de confirmação e exclusão definitiva: até 72 horas úteis.
      </div>
    </div>
  );
}
